/* eslint-disable camelcase */
import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPageSlixta } from '../../../components/BaseEntityPageSlixta';
import { UiHelper } from '../../../common/helpers/UiHelper';
import { AppConfig } from '../../../AppConfig';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { AppUiHelper } from '../../../helpers/AppUiHelper';
import { Controller } from '../../../common/Controller';
import { SubEntityCard } from '../../../common/components/SubEntity/SubEntityCard';
import { SubEntityList } from '../../../common/components/SubEntity/SubEntityList';
import WhatsappTemplatePreview from '../../../common/components/WhatsappTemplatePreview';
import { buildPreviewComponentsFromTemplate } from './WhatsappPreviewAdapter';
import { CommonStyles, CommonTheme } from '../../../styles/Styles';
import { StatCard } from '../../../common/components/StatCard';
import { CbSelection } from '../../../common/components/CbSelection';
import { UploadHelper } from '../../../common/helpers/UploadHelper';
import { AppHelper } from '../../../helpers/AppHelper';
import { buildWaNumberLabel, buildWaNumberSelectOptions, getWaOrgAccountNumbers } from './WhatsappUtils';
import {
  canStartEmailBroadcast,
  getEmailBroadcastMode,
  isPinpointBroadcast,
  isSesBroadcast,
} from './CampaignsBase';

function getCampaignFields(obj) {
  const transformField = (field, iType) => {
    const outField = JSON.parse(JSON.stringify(field))
    if (field.condition && ((field.condition.value && field.condition.value === iType) || (field.condition.values && field.condition.values.includes(iType)))) {
      delete outField.condition
    }
    return outField
  }
  return {
    AD: obj.fieldDefCampaignAd.steps[0].fields.map(f => transformField(f, 'AD')),
    BROADCAST: obj.fieldDefCampaignBroadcast.steps[0].fields.map(f => transformField(f, 'BROADCAST')),
    TRANSACTIONAL: obj.fieldDefCampaignTransactional.steps[0].fields.map(f => transformField(f, 'TRANSACTIONAL')),
    NOTIFICATION: obj.fieldDefCampaignNotification.steps[0].fields.map(f => transformField(f, 'NOTIFICATION')),
    DRIP: obj.fieldDefCampaignDrip.steps[0].fields.map(f => transformField(f, 'DRIP')),
  }[obj.campaignType] || []
}
function restrictChannels(fieldDef, channels, defaultValue) {
  const channelField = fieldDef.steps[0].fields.find(f => f.key === 'channel')
  channelField.options = channelField.options.filter(o => channels.includes(o.key))
  channelField.defaultValue = defaultValue
}

function canCancelOrReschedule(campaign) {
  return campaign && campaign.iType === 'BROADCAST' && campaign.state === 'SCHEDULED' && campaign.scheduleType === 'LATER' &&
         (campaign.channel === 'WHATSAPP' || (campaign.channel === 'EMAIL' && (isSesBroadcast(campaign) || isPinpointBroadcast(campaign))))
}
function getWaTemplateComponentText(current) {
  if (current.text) {
    return current.text
  } else if (current.type === 'BUTTONS' && current.buttons) {
    return current.buttons.map(b => [b.type, b.text + (b.url ? ` [${b.url}]` : '')].filter(s => !!s).join(': ')).join('\n')
  } else if (current.format) {
    return `{{${current.format.toLowerCase()}}}`
  } else {
    return ''
  }
}
function getWhatsAppMetadataCardFieldDef() {
  return {
    title: 'WhatsApp Template',
    steps: [
      {
        fields: [
          {
            key: 'fromNumberDisplay',
            type: 'edit_text',
            label: 'From Number (WABA)',
            tip: 'WhatsApp Business Account phone number',
            disabled: true,
            placement: 'left',
          },
          {
            key: 'templateId',
            type: 'edit_text',
            label: 'Template',
            tip: 'WhatsApp template',
            disabled: true,
            placement: 'right',
          },
          {
            key: 'templateCategory',
            type: 'edit_text',
            label: 'Category',
            tip: 'WhatsApp template category',
            disabled: true,
            placement: 'left',
          },
        ],
      },
    ],
  }
}

function getWhatsAppMetadataFieldDef(options) {
  const {waAccounts, waTemplates = [], orgId, ctaButtonText, current} = options
  const waOrgAccounts = waAccounts[orgId]
  const { fromNumbers, waNumberDetails } = getWaOrgAccountNumbers(waOrgAccounts)
  const fieldDef = {
    title: 'WhatsApp Template',
    ctaButtonText: ctaButtonText || 'Next',
    steps: [
      {
        fields: [
          {
            key: 'fromNumber',
            type: 'radio',
            label: 'From Number (WABA)',
            tip: 'Select the From Number (WABA)',
            options: buildWaNumberSelectOptions(fromNumbers, waNumberDetails),
            v_required: {
              value: true,
              err: 'Provide WhatsApp Account'
            },
            placement: 'left'
          },
          {
            key: 'templateId',
            type: 'radio',
            label: 'Template',
            tip: 'Select WhatsApp Template',
            options: waTemplates.map(waT => ({
              label: waT.category ? `${waT.name} (${waT.category})` : waT.name,
              key: waT.name
            })),
            v_required: {
              value: true,
              err: 'Provide WhatsApp Template'
            },
            placement: 'right'
          },
          {
            key: 'templateCategory',
            type: 'edit_text',
            label: 'Category',
            tip: 'WhatsApp template category',
            disabled: true,
            placement: 'left'
          },
        ]
      }
    ]
  }
  return fieldDef
}

function getFieldDefWATemplateVariable(current, crmContactsFieldDef = null) {
  const fields = []
  const currentFormat = (current && current.format) ? String(current.format).toLowerCase() : ''
  if(currentFormat === 'image') {
    fields.push({
      key: 'media',
      linkName: 'mediaLink',
      type: 'edit_text',
      label: 'Image (PNG/JPEG, max 1920px height)',
      imageHeight: 1920,
      mode: 'fit',
      tip: 'Upload an image in PNG or JPEG format',
      v_required: { value: true, err: 'Provide image'},
      v_min: {value: 1, err: 'Invalid image'},
      v_max: {value: 100, err: 'Invalid image'},
      imageUpload: true,
      uploadType: 'media',
      uploadAccept: 'image/png, image/jpeg',
      placement: 'left'
    })
  } else if (currentFormat === 'text') {
    fields.push({
      key: 'text',
      type: 'radio',
      label: 'Contact Variable',
      tip: 'Choose one of the contact variables (or enter a custom text)',
      options: AppUiHelper.getContactTemplateVariables(crmContactsFieldDef).map(ctv => ({key: ctv.value, label: ctv.text})).concat({key: 'custom', label: '[Custom Text]'}),
      v_required: {
        value: true,
        err: 'Choose one of the contact variables (or enter a custom text)'
      },
      placement: 'left'
    })
    fields.push({
      condition: {key: 'text', value: 'custom', values: ['custom']},
      key: 'customText',
      type: 'edit_text',
      label: 'Custom Value',
      tip: 'Enter any text',
      v_required: {
        value: true,
        err: 'Provide custom value'
      },
      placement: 'left'
    })
  } else if(currentFormat === 'video') {
    fields.push({
      key: 'media',
      label: 'Video (MP4, max 16MB file size)',
      hint: 'Upload a video in MP4 format',
      v_required: {
        value: true,
        err: 'Provide video'
      },
      placement: 'left',
      type: 'edit_text',
      subType: 'VIDEO',
      documentUpload: true,
      linkName: 'mediaLink',
      v_min: {
        value: 1,
        err: 'Invalid video'
      },
      v_max: {
        value: 100,
        err: 'Invalid video'
      },
      uploadType: 'media',
      uploadAccept: 'video/mp4',
      fileSizeLimit: 16000000
    })
  } else if (currentFormat === 'document') {
    fields.push({
      key: 'media',
      linkName: 'mediaLink',
      label: 'Document',
      hint: 'Upload PDF document (max 20MB)',
      v_required: { value: true, err: 'Provide document' },
      placement: 'left',
      type: 'edit_text',
      documentUpload: true,
      v_min: { value: 1, err: 'Invalid document' },
      v_max: { value: 100, err: 'Invalid document' },
      uploadType: 'media',
      uploadAccept: 'application/pdf',
      fileSizeLimit: 20000000
    })
    fields.push({
      key: 'fileName',
      type: 'edit_text',
      label: 'File Name',
      tip: 'Set the document filename to send',
      v_required: { value: true, err: 'Provide file name' },
      placement: 'right'
    })
  }

  const fieldDef = {
    title: 'Edit',
    ctaButtonText: 'Save',
    steps: [
      {
        fields,
      }
    ]
  }
  return fieldDef
}

function renderWaTemplateVariablesValue(current) {
  const currentFormat = (current && current.format) ? String(current.format).toLowerCase() : ''
  if(current && currentFormat === 'image' && current.mediaLink) {
    return (
      <div className={css(Styles.imageWrapper)}>
        <img
          src={current.mediaLink}
          alt={current.media || current.mediaLink || 'Preview'}
          className={css(Styles.imagePreview)}
        />
      </div>
    )
  }  if (currentFormat === 'video' && current.mediaLink) {
    return (
      <div className={css(Styles.videoWrapper)}>
        <video
          src={current.mediaLink}
          controls
          controlsList='nodownload noplaybackrate'
          className={css(Styles.videoPreview)}
        />
      </div>
    )
  } else if (current && currentFormat === 'document' && current.mediaLink) {
    return (
      <div>
        <a href={current.mediaLink} target='_blank' rel='noopener noreferrer' className={css(Styles.spanValue)}>
          Open document
        </a>
      </div>
    )
  } else if (current && currentFormat === 'text' && current.text) {
    return (
      <div>
        <span className={css(Styles.spanValue)}>
          {current.text}
        </span>
      </div>
    )
  }

  return (
    <div>
      <span className={css(Styles.spanValue)}>
        {current.text || current.mediaLink || current.media || '[Not Set]'}
      </span>
    </div>
  );
}


export class CampaignDetail extends BaseEntityPageSlixta {
  constructor(props) {
    super(props);
    this.ms = AppConfig.CDP_MS.ENDPOINT
    this.pageTitle = 'Campaign Detail'
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.campaignId = this.props.match.params.id
    this.staffUserId = Controller.get().getUserId()
    this.attribsGroupId = 'settingscrmcontactattrs' + this.orgId
    this.breadCrumbs = [
      { title: Helper.getString('backToBroadcasts'), to: this.baseRoute() + '/campaigns/broadcasts', type: 'button', icon: 'arrow_back_ios' },
    ]
    this.toFetch = [
      { key: 'campaign', ms: this.ms, method: 'GET', paths: ['campaigns', this.campaignId], queryParams: { orgId: this.orgId, pb: 'fieldDefCampaignAd,fieldDefCampaignBroadcast,fieldDefCampaignTransactional,fieldDefCampaignNotification,fieldDefCampaignDrip,fieldDefCampaignSchedule' , includeStats: 'YES'} },
      { key: 'waAccounts', ms: this.ms, method: 'GET', paths: ['miscs', 'get-wa-accounts'], queryParams: { orgId: this.orgId } },
      { key: 'crmInteractions', ms: this.ms, method: 'GET', paths: ['crminteractions'], queryParams: { orgId: this.orgId, campaignId: this.campaignId, limit: 500 } },
      { key: 'crmContacts', ms: this.ms, method: 'GET', paths: ['crmcontacts'], queryParams: { orgId: this.orgId, pb: 'fieldDef', includeCustomFields: 'true', limit: 1 } },
    ]
    this.apiData = {
      orgId: this.orgId
    }
    this.pageKey = this.pageTitle
    this.noAdd = true
    this.entityAttrName = 'blocks'
    this.whatsappMetadataCardFieldDef = getWhatsAppMetadataCardFieldDef()
    this.waNumberDetails = undefined
    this.individualStatsTableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => {
        let contactPhone = (current._waMsgResponse && current._waMsgResponse.contactPhone) || ''
        contactPhone = contactPhone ? `<${contactPhone}>` : ''
        return <div>
          <span className={css(Styles.line1)}>{[current.entityName || '', contactPhone].filter(i => !!i).join(' ')}</span>
        </div>
      },
      Status: (current) => {
        let displayTs, displayMsg
        if (current._waMsgResponse) {
          if (current._waMsgResponse.readTs) { displayTs = current._waMsgResponse.readTs; displayMsg = 'READ'; }
          else if (current._waMsgResponse.deliveredTs) { displayTs = current._waMsgResponse.deliveredTs; displayMsg = 'DELIVERED'; }
          else if (current._waMsgResponse.sentTs) { displayTs = current._waMsgResponse.sentTs; displayMsg = 'SENT'; }
          else if (current._waMsgResponse.failedTs) {
            displayTs = current._waMsgResponse.failedTs
            const errorCode = current._waMsgResponse.failedReasonParsed && Array.isArray(current._waMsgResponse.failedReasonParsed.errors) && current._waMsgResponse.failedReasonParsed.errors.length > 0 && current._waMsgResponse.failedReasonParsed.errors[0].code
            if (errorCode === 131049) {
              displayMsg = 'SKIPPED BY META'
            } else if (errorCode === 131026) {
              displayMsg = 'UNDELIVERABLE'
            } else {
              displayMsg = 'ERROR' + (errorCode ? ' (' + errorCode + ')' : '')
            }
          } else if (current._waMsgResponse.createdTs) {
            displayTs = current._waMsgResponse.createdTs
            displayMsg = 'ACCEPTED'
          }
        } else {
          if (current.payload && current.payload.waResponse && Array.isArray(current.payload.waResponse.items) && current.payload.waResponse.items.length > 0) {
            if (current.payload.waResponse.items[0] && current.payload.waResponse.items[0].message && current.payload.waResponse.items[0].message.message_status === 'accepted') {
              displayMsg = 'ACCEPTED'
              displayTs = current.createdTs
            } else {
              displayMsg = 'SYSTEM ERROR'
            }
          }
        }
        return displayMsg ? <div><span className={css(Styles.line1)}>{displayMsg}</span><br/>{displayTs && <span className={css(Styles.line2)}>{Helper.formatTimestamp(displayTs)}</span>}</div> : ''
      },
    }
    this.individualEmailStatsTableHeadersMap = {
      Index: (current) => current.__index + 1,
      Info: (current) => {
        const payload = current.payload || {}
        let email = ''
        if (current.emailTo) {
          email = Array.isArray(current.emailTo) ? current.emailTo.join(', ') : current.emailTo
        } else if (payload.emailTo) {
          email = Array.isArray(payload.emailTo) ? payload.emailTo.join(', ') : payload.emailTo
        } else if (payload.emailRequest && payload.emailRequest.emailTo) {
          email = Array.isArray(payload.emailRequest.emailTo) ? payload.emailRequest.emailTo.join(', ') : payload.emailRequest.emailTo
        }
        email = email ? `<${email}>` : ''

        return <div>
          <span className={css(Styles.line1)}>{[current.entityName || '', email].filter(i => !!i).join(' ')}</span>
        </div>
      },
      Status: (current) => {
        const payload = current.payload || current || {}
        const emailResponse = payload.emailResponse || {}
        let displayMsg = 'PENDING'
        const errorMsg = emailResponse.errorMessage

        if (errorMsg) {
          displayMsg = 'ERROR'
        } else if (emailResponse.MessageId) {
          displayMsg = 'SENT'
        }

        const bounce = payload.bounceCount || 0
        const click = payload.clickCount || 0
        const delivered = payload.deliveredCount || 0
        const open = payload.openCount || 0
        const reply = payload.replyCount || 0

        return <div>
          <span className={css(Styles.line1)}>{displayMsg}</span>
          {errorMsg && <span className={css(Styles.line2)} style={{color: '#EA0038'}}>&nbsp;[{errorMsg}]</span>}
          <br/>
          <span className={css(Styles.line2)}>Delivered: {delivered}</span>
          <span className={css(Styles.line2)}>{'\u00A0'}|{'\u00A0'}</span>
          <span className={css(Styles.line2)}>Open: {open}</span>
          <span className={css(Styles.line2)}>{'\u00A0'}|{'\u00A0'}</span>
          <span className={css(Styles.line2)}>Click: {click}</span>
          <span className={css(Styles.line2)}>{'\u00A0'}|{'\u00A0'}</span>
          <span className={css(Styles.line2)}>Reply: {reply}</span>
          <span className={css(Styles.line2)}>{'\u00A0'}|{'\u00A0'}</span>
          <span className={css(Styles.line2)}>Bounce: {bounce}</span>
        </div>
      },
    }
  }

  async onFetchSuccess(results) {
    this.campaign = this.getResult(results, 'campaign')
    this.waAccounts = this.getResult(results, 'waAccounts')
    this.crmInteractions = this.getResult(results, 'crmInteractions') || {items: []}
    this.crmContactsFieldDef = this.getResult(results, 'crmContacts') && this.getResult(results, 'crmContacts').fieldDef
    if (this.campaign.channel === 'WHATSAPP' && this.campaign.state === 'COMPLETED' && Array.isArray(this.campaign._executionResults) && this.crmInteractions.items.length > 0) {
      this.crmInteractions.items.forEach(ci => {
        const waRequestPhoneNumber = ci.payload && ci.payload.waRequest && Array.isArray(ci.payload.waRequest.messageParams) && ci.payload.waRequest.messageParams[0] && ci.payload.waRequest.messageParams[0].toNumber || ''
        ci._waMsgResponse = this.campaign._executionResults.find(er => er.contactPhone === waRequestPhoneNumber)
      })
    }
    this.campaignType = this.campaign.iType
    if (this.campaign.channel === 'WHATSAPP') { this.enableAssetPicker() }

    if(this.campaign.state === 'DRAFT') {
      this.state.orderUIMode = ApiHelper.ORDER_UI_MODE.INTERACTIVE
    }

    if (this.campaignType === 'BROADCAST') {
      this.csegments = await ApiHelper.callAwait({ key: 'csegments', ms: this.ms, method: 'GET', paths: ['csegments'], queryParams: { orgId: this.orgId, limit: 100 } })
      this.csegments.items = this.csegments.items.filter(s => {
        if (this.campaign.channel === 'WHATSAPP') return s.type === 'FILTER'
        if (this.campaign.channel === 'EMAIL') {
          return isSesBroadcast(this.campaign) ? s.type === 'FILTER' : s.type === 'USERGEN'
        }
        return false
      })
    }
    if (['BROADCAST', 'NOTIFICATION', 'TRANSACTIONAL'].includes(this.campaignType)) {
      if(this.campaign && this.campaign.channel === 'EMAIL') {
        this.emailpagesOrg = await ApiHelper.callAwait({ key: 'emailpages', method: 'GET', paths: ['emailpages'], queryParams: { orgId: this.orgId, pb: 'fieldDef' } })
        this.emailpagesPRODUCT = await ApiHelper.callAwait({ key: 'emailpages-PRODUCT', method: 'GET', paths: ['emailpages'], queryParams: { orgId: 'PRODUCT' } })
      }
    }
    //this.sharedCrmInboxes = this.getResult(results, 'crminboxes').items.filter(i => i.sharedInbox === 'YES')
    //this.crmContactAttrs = this.getResult(results, 'crmcontactattrs')

    this.fieldDefCampaignAd = this.campaign.fieldDefCampaignAd
    this.fieldDefCampaignBroadcast = this.campaign.fieldDefCampaignBroadcast
    this.fieldDefCampaignTransactional = this.campaign.fieldDefCampaignTransactional
    this.fieldDefCampaignNotification = this.campaign.fieldDefCampaignNotification
    this.fieldDefCampaignDrip = this.campaign.fieldDefCampaignDrip
    this.fieldDefCampaignSchedule = this.campaign.fieldDefCampaignSchedule
    if (this.campaignType === 'BROADCAST') this.fieldDef = this.fieldDefCampaignBroadcast
    else if (this.campaignType === 'NOTIFICATION') this.fieldDef = this.fieldDefCampaignNotification
    else if (this.campaignType === 'TRANSACTIONAL') this.fieldDef = this.fieldDefCampaignTransactional
    else if (this.campaignType === 'DRIP') this.fieldDef = this.fieldDefCampaignDrip
    else if (this.campaignType === 'AD') this.fieldDef = this.fieldDefCampaignAd

    restrictChannels(this.fieldDefCampaignAd, ['OOH'], 'OOH')
    restrictChannels(this.fieldDefCampaignBroadcast, ['EMAIL', 'WHATSAPP'], 'EMAIL')
    restrictChannels(this.fieldDefCampaignTransactional, ['EMAIL'], 'EMAIL')
    restrictChannels(this.fieldDefCampaignNotification, ['EMAIL'], 'EMAIL')

    this.fieldDefCampaignBroadcast = UiHelper.removeFields(this.fieldDefCampaignBroadcast, ['templateId'])
    this.fieldDefCampaignBroadcast.steps[0].fields.push({
      type: 'edit_text',
      key: 'state',
      label: 'Status',
      tip: 'Current state of the campaign',
      disabled: true,
      placement: 'left',
      v_required: { value: true, err: 'Provide status' },
    })
    if (this.campaignType === 'BROADCAST' && this.campaign.channel === 'EMAIL') {
      const emailBroadcastMode = getEmailBroadcastMode(this.orgId)
      let broadcastModeValue = null
      if (emailBroadcastMode === 'NEW' && isPinpointBroadcast(this.campaign)) {
        broadcastModeValue = 'LEGACY'
      } else if (emailBroadcastMode === 'EXPERIMENTAL') {
        broadcastModeValue = isSesBroadcast(this.campaign) ? 'NEW' : 'LEGACY'
      }
      if (broadcastModeValue) {
        this.campaign._broadcastModeDisplay = broadcastModeValue
        this.fieldDefCampaignBroadcast.steps[0].fields.push({
          type: 'edit_text',
          key: '_broadcastModeDisplay',
          label: 'Broadcast Mode',
          disabled: true,
          placement: 'left',
          v_required: { value: false, err: '' },
        })
      }
    }
    let dateFieldLabel = null;
    let dateFieldValue = null;
    let dateFieldKey = null;
    // SCHEDULED campaigns
    if (this.campaign.state === 'SCHEDULED') {
      dateFieldLabel = 'Scheduled on';
      if (this.campaign.scheduleType === 'LATER' && this.campaign.scheduleTs) {
        dateFieldValue = this.campaign.scheduleTs;
        dateFieldKey = 'scheduleTs';
      } else if (
        this.campaign.scheduleType === 'IMMEDIATE' &&
        this.campaign._extCampaign &&
        this.campaign._extCampaign.creationDate
      ) {
        dateFieldValue = this.campaign._extCampaign.creationDate;
        dateFieldKey = 'creationDate';
      }
    }
    // COMPLETED campaigns
    else if (this.campaign.state === 'COMPLETED') {
      dateFieldLabel = 'Executed on';
      if (this.campaign.executeTs) {
        dateFieldValue = this.campaign.executeTs;
        dateFieldKey = 'executeTs';
      } else if (this.campaign.scheduleType === 'LATER'
        && this.campaign.scheduleTs) {
        dateFieldValue = this.campaign.scheduleTs;
        dateFieldKey = 'scheduleTs';
      } else if (this.campaign.scheduleType === 'IMMEDIATE'
        && this.campaign._extCampaign
        && this.campaign._extCampaign.creationDate) {
        dateFieldValue = this.campaign._extCampaign.creationDate;
        dateFieldKey = 'creationDate';
      }
    }

    if (dateFieldKey && dateFieldValue) {
      this.campaign[dateFieldKey] = Helper.formatTimestamp(dateFieldValue);
    }

    if (dateFieldLabel && dateFieldValue && dateFieldKey && this.campaign.state === 'SCHEDULED') {
      this.fieldDefCampaignBroadcast.steps[0].fields.push({
        type: 'edit_text',
        key: dateFieldKey,
        label: dateFieldLabel,
        disabled: true,
        placement: 'left',
        tip: `${dateFieldLabel} of the campaign`,
        v_required: { value: true, err: 'Provide date' },
      });
    }

    this.fieldDefCampaignBroadcast.steps[0].fields.find(f => f.key === 'channel').disabled = true
    this.fieldDefCampaignBroadcast = UiHelper.reflowFields(this.fieldDefCampaignBroadcast)

    if (this.campaignType === 'AD') {
      this.fieldDefCampaignSchedule.disableAlwaysFormFields = ['scheduleType']
    } else {
      UiHelper.fieldDefDeleteField(this.fieldDefCampaignSchedule, 'scheduleEndTs')
    }

    if (this.csegments) {
      this.segments = this.csegments.items.filter(i => i.state === 'LIVE')
      UiHelper.populateOptions(this.fieldDefCampaignBroadcast, {items: this.segments}, 'segmentId')
    } else {
      this.segments = []
    }
    if (this.campaign.iType === 'BROADCAST' && this.campaign.channel === 'WHATSAPP' && this.campaign.segmentId) {
      const segment = await ApiHelper.callAwait({
        ms: AppConfig.CDP_MS.ENDPOINT,
        method: 'GET',
        paths: ['csegments', this.campaign.segmentId],
        queryParams: {orgId: this.orgId, includeCount: true}
      })
      this.segmentLiveCount = segment._count || null
      const segmentsField = Helper.getField(this.fieldDefCampaignBroadcast, 'segmentId')
      if (segmentsField) {
        segmentsField.options.forEach(o => {
          if (o.key === this.campaign.segmentId) {
            o.href = this.baseRoute() + '/crm-contacts?' + segment.filtersQs
            o.openInNewTab = true
          }
        })
      }
    }
    if (this.campaign.iType === 'BROADCAST' && this.campaign.channel === 'EMAIL' && this.campaign.segmentId) {
      try {
        const segment = await ApiHelper.callAwait({
          ms: AppConfig.CDP_MS.ENDPOINT,
          method: 'GET',
          paths: ['csegments', this.campaign.segmentId],
          queryParams: {orgId: this.orgId, includeCount: true}
        })
        const segmentsField = Helper.getField(this.fieldDefCampaignBroadcast, 'segmentId')
        if (segmentsField) {
          let option = segmentsField.options && segmentsField.options.find(o => o.key === this.campaign.segmentId)
          if (!option) {
            option = { key: this.campaign.segmentId, text: segment.title, label: segment.title }
            segmentsField.options = segmentsField.options || []
            segmentsField.options.push(option)
          } else {
            option.text = segment.title
            option.label = segment.title
          }
          if (segment.filtersQs) {
            option.href = this.baseRoute() + '/crm-contacts?' + segment.filtersQs
            option.openInNewTab = true
          }
        }
      } catch (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err),
        })
        throw err
      }
    }

    if (this.emailpagesOrg && this.emailpagesPRODUCT) {
      this.emailPages = [
        ...this.emailpagesOrg.items,
        ...this.emailpagesPRODUCT.items.filter(i => i.state === 'LIVE').map(i => ({...i, title: `[${i.title}]`})),
      ]
      UiHelper.populateOptions(this.fieldDefCampaignBroadcast, {items: this.emailPages}, 'templateId')
      UiHelper.populateOptions(this.fieldDefCampaignTransactional, {items: this.emailPages}, 'templateId')
      UiHelper.populateOptions(this.fieldDefCampaignNotification, {items: this.emailPages}, 'templateId')
    } else {
      this.emailPages = []
    }

    //UiHelper.populateOptions(this.fieldDefCampaignDrip, {items: this.sharedCrmInboxes.map(i => ({id: i.id, title: i.email}))}, 'triggerInboxId')
    //UiHelper.populateOptions(this.fieldDefCampaignDrip, {items: Helper.extractAttrs(this.crmContactAttrs, 'tags').map(t => ({id: t, title: t}))}, 'triggerOnTags')

    if (this.campaignType === 'BROADCAST') {
      if(this.campaign) {
        if(this.campaign.channel === 'EMAIL') {
          this.emailTemplate = await ApiHelper.callAwait({ method: 'GET', paths: ['emailpages', this.campaign.templateId], queryParams: { orgId: this.orgId, pb: 'fieldDef,fieldDefPageBlock' } })
          this.emailTemplate.subject = this.emailTemplate.subject || ''
          this.emailTemplate.previewText = this.emailTemplate.previewText || ''
          this.emailTemplate.titleText = this.emailTemplate.titleText || ''
          this.emailTemplateFieldDef = this.emailTemplate.fieldDef
          this.emailTemplateFieldDef = UiHelper.removeFields(this.emailTemplateFieldDef, ['title', 'state'])
          this.emailTemplateFieldDef = UiHelper.reflowFields(this.emailTemplateFieldDef)
          this.emailTemplateSubject = this.emailTemplateFieldDef.steps[0].fields.find(o => o.key === 'subject')
          this.emailTemplateSubject.tip = 'The subject of the email'
          this.emailTemplatePreviewText = this.emailTemplateFieldDef.steps[0].fields.find(o => o.key === 'previewText')
          this.emailTemplatePreviewText.tip = 'The inbox preview of the email (shown by some email clients like Gmail)'
          this.emailTemplatePreviewText.advanced = true
          this.emailTemplateTitleText = this.emailTemplateFieldDef.steps[0].fields.find(o => o.key === 'titleText')
          this.emailTemplateTitleText.tip = 'The title of the email (shown by some web email clients in the title bar or page tab)'
          this.emailTemplateTitleText.advanced = true
          this.cbSource = this.emailTemplate.fieldDefPageBlock.steps[0].fields.find(o => o.key === 'cbSource')
          if(this.cbSource && this.cbSource.options) {
            this.cbSource.options = this.cbSource.options.filter(o => o.key === 'GLOBAL')
          }
          this.cbGlobal = await ApiHelper.callAwait({ method: 'GET', paths: ['emailcbdefs'], queryParams: { orgId: 'PRODUCT', pb: 'fieldDef' } })
          this.cbGlobalById = Helper.itemsToMap(this.cbGlobal.items)
          UiHelper.populateOptions(this.emailTemplate.fieldDefPageBlock, this.cbGlobal, 'cbGlobalId')
          const widgets = Helper.sortDictArray(Helper.dictToArray(this.emailTemplate.blocks))
          widgets.forEach(i => {
            if(i.cbGlobalId && this.cbGlobalById[i.cbGlobalId]) {
              i._widgetName = this.cbGlobalById[i.cbGlobalId].title
              i._cbstyle = this.cbGlobalById[i.cbGlobalId].cbstyle
              i._singleton = this.cbGlobalById[i.cbGlobalId].singleton
              i._cbScopeId = 'p' + this.orgId + '-' + i.id + '-' + i.cbGlobalId
            }
          })
          this.emailTemplateHeaders = {
            Order: current => current.order,
            Section: current => <div>
              <span className={css(Styles.spanValue)}>{current.title || '(no nickname)'}</span>
              <br/>
              <span className={css(Styles.spanValue, Styles.line2)}>{current._widgetName}</span>
            </div>,
            Status: current => UiHelper.itemStatusContainer(current),
          }
        }
        else if (this.campaign.channel === 'WHATSAPP') {
          const { waNumberDetails } = getWaOrgAccountNumbers(this.waAccounts && this.waAccounts[this.orgId])
          this.waNumberDetails = waNumberDetails
          this.waSettings = {
            fromNumber: this.campaign.fromNumber || '',
            fromNumberDisplay: buildWaNumberLabel(this.campaign.fromNumber || '', waNumberDetails) || '',
            templateId: this.campaign.templateId || '',
            templateCategory: (this.campaign.waTemplate && this.campaign.waTemplate.category) || '',
            waComponents: this.campaign.waComponents || {},
          }
          this.waTemplateHeaders = {
            Index: current => current.__index + 1,
            Type: current => <div>
              <span className={css(Styles.spanValue)}>{current.type.toUpperCase() || ''}</span>
            </div>,
            Format: current => <div>
              <span className={css(Styles.spanValue)}>{(current.format || 'TEXT').toUpperCase()}</span>
            </div>,
            Value: current => <div>
              <span className={css(Styles.spanValue, Styles.preWrapText)}>{getWaTemplateComponentText(current)}</span>
            </div>,
          }
          this.waTemplateVariablesHeaders = {
            Index: current => current.__index + 1,
            Type: current => <div>
              <span className={css(Styles.spanValue)}>{current.type.toUpperCase() || ''}</span>
            </div>,
            Format: current => <div>
              <span className={css(Styles.spanValue)}>{current.format.toUpperCase() + (current.vIndex ? ` {{${current.vIndex}}}` : '') || ''}</span>
            </div>,
            Value: current => renderWaTemplateVariablesValue(current),
          }
          if(this.campaignType === 'BROADCAST' && this.campaign.channel === 'WHATSAPP' && (!this.campaign.fromNumber || !this.campaign.templateId)) {
            this.openModalForEditWhatsAppMetaData(this.waSettings)
          }
        }
      }
    }

    this.pageTitle = this.campaign.title

    if(this.campaignType === 'BROADCAST' && this.campaign.channel === 'WHATSAPP') {
      this.headerActions = [
        {
          label: 'Refresh',
          tooltip: 'Refresh',
          icon: 'refresh',
          type: 'icon-label',
          onClick: () => this.fetchItems(),
        }
      ]
    } else {
      this.headerActions = [
        {
          label: 'Preview',
          tooltip: 'Preview',
          icon: 'desktop_windows',
          type: 'icon-label',
          onClick: () => window.open('/admin/orgs/' + this.orgId + '/preview?templateId=' + this.emailTemplate.id, 'slixtaPreivew'),
        },
        {
          label: 'Refresh',
          tooltip: 'Refresh',
          icon: 'refresh',
          type: 'icon-label',
          onClick: () => this.fetchItems(),
        }
      ]
    }

    if(this.campaignType === 'BROADCAST' && this.campaign.channel === 'WHATSAPP' && (!this.campaign.fromNumber || !this.campaign.templateId)) {
      this.headerActions.unshift({
        label: 'Select Template',
        tooltip: 'Select an WhatsApp Account and a Template to begin.',
        icon: 'chat',
        onClick: () => this.openModalForEditWhatsAppMetaData(this.waSettings)
      })
    } else {
      if (['DRAFT', 'PAUSED'].includes(this.campaign.state)) {
        this.emailMetadataIssues = []
        if (this.campaign.channel === 'EMAIL') {
          if (!this.campaign.templateId) {
            this.emailMetadataIssues.push('Email template not selected')
          } else if (this.emailTemplate && (!this.emailTemplate.subject || !this.emailTemplate.subject.trim())) {
            this.emailMetadataIssues.push('Email subject is empty')
          }
          if (this.emailTemplate && (!this.emailTemplate.blocks || Object.keys(this.emailTemplate.blocks).length === 0)) {
            this.emailMetadataIssues.push('Email metadata is missing')
          }
        }

        const canStart = canStartEmailBroadcast(this.campaign, this.orgId)
        this.headerActions.unshift({
          label: this.campaign.state === 'PAUSED' ? 'Resume' : 'Start',
          tooltip: canStart
            ? (this.campaign.state === 'PAUSED' ? 'Resume' : 'Start')
            : 'Start not available for this broadcast mode',
          icon: 'send',
          type: 'icon-label',
          disabled: !canStart,
          onClick: canStart
            ? () => this.updateCampaignState(this.campaign, this.campaign.state === 'PAUSED' ? 'resume' : 'start')
            : undefined,
        })
      }
      if (['LIVE'].includes(this.campaign.state)) {
        this.headerActions.unshift({
          label: 'Pause',
          tooltip: 'Pause',
          icon: 'pause',
          onClick: () => this.updateCampaignState(this.campaign, 'pause')
        })
      }
      if (canCancelOrReschedule(this.campaign)) {
        this.headerActions.unshift({
          label: 'Reschedule',
          tooltip: 'Reschedule Campaign',
          icon: 'schedule_send',
          type: 'icon-label',
          onClick: () => this.openModalForRescheduleBroadcast()
        })
        this.headerActions.unshift({
          label: 'Cancel',
          tooltip: 'Cancel Campaign',
          icon: 'cancel_schedule_send',
          type: 'icon-label',
          onClick: () => this.handleCancelBroadcast()
        })
      }
    }
    /*this.setState(prevState => {
      const newState = JSON.parse(JSON.stringify(prevState))
      newState.headerActions = this.headerActions
      return newState
    })*/

    /*this.setState({
      items: ,//this.campaigns.items.sort((a, b) => b.createdTs - a.createdTs)
    })*/
    // this.setState({
    //   item: this.campaign,
    // })

    const interactionsList = this.crmInteractions && Array.isArray(this.crmInteractions.items) ? this.crmInteractions.items : [];
    this.setState({
      interactions: interactionsList,
      interactionsNextPage: this.crmInteractions && this.crmInteractions.nextPage,
    })
  }

  renderAboveTable() {
    let tiles = []
    if (this.campaignType === 'BROADCAST') {
      if (this.campaign.channel === 'EMAIL' && this.campaign.state !== 'DRAFT') {
        if (isSesBroadcast(this.campaign)) {
          const stats = this.campaign.executeStats || {}
          const attempted = stats.attemptedCount || 0
          const segmentSize = stats.segmentCount || 0

          tiles = [
            { title: 'Delivery', value: (attempted > 0 ? Math.round((stats.deliveredCount || 0) / attempted * 100) : 0) + '%' },
            { title: 'Bounce', value: (attempted > 0 ? Math.round((stats.bounceCount || 0) / attempted * 100) : 0) + '%' },
            { title: 'Opens', value: (attempted > 0 ? Math.round((stats.openCount || 0) / attempted * 100) : 0) + '%' },
            { title: 'Clicks', value: Math.round(stats.clickCount || 0) },
            { title: 'Executed Segment Size', value: segmentSize },
            { title: 'Attempted', value: Math.round(attempted) },
            { title: 'Recipients', value: Math.round(stats.deliveredCount || 0) },
            { title: 'Opens', value: Math.round(stats.openCount || 0) },
          ]
        } else {
          const r = this.campaign._extCampaignPerformance ? this.campaign._extCampaignPerformance.kpis : null
          if (r) {
            tiles = [
              { title: 'Delivery', value: Math.round(r['delivery-rate'].percent) + '%' },
              { title: 'Bounce', value: Math.round(r['hard-bounce-rate'].percent) + '%' },
              { title: 'Opens', value: Math.round(r['open-rate'].percent) + '%' },
              { title: 'Clicks', value: Math.round(r.clicks.count) },
              { title: 'Attempted', value: Math.round(r['attempted-deliveries'].count) },
              { title: 'Successful', value: Math.round(r['successful-deliveries'].count) },
              { title: 'Recipients', value: Math.round(r['unique-deliveries'].count) },
              { title: 'Opens', value: Math.round(r['email-opens'].count) },
            ]
          }
        }
      } else if (this.campaign.channel === 'WHATSAPP') {
        if (this.campaign.state !== 'DRAFT') {
          const executionResults = this.campaign._executionResults || []
          const segmentSize =  (this.campaign.executeStats && this.campaign.executeStats.segmentCount) || 0
          const attempted = (this.campaign.executeStats && this.campaign.executeStats.attemptedCount) || ('executeSegSize' in this.campaign ? this.campaign.executeSegSize : executionResults.length) || 0
          const success = executionResults.filter(er => !!er.sentTs).length
          const delivered = executionResults.filter(er => !!er.deliveredTs).length
          tiles = [
            { title: 'Attempted', value: attempted },
            { title: 'Sent', value: success },
            { title: 'Delivered', value: delivered },
            { title: 'Delivery', value: Math.round(100 * (delivered / (attempted || 1))) + '%' },
          ]
          if (segmentSize) {
            tiles.unshift({ title: 'Executed Segment Size', value: segmentSize })
          }
        } else {
          const segmentSize = this.segmentLiveCount
          if (Number.isInteger(this.segmentLiveCount)) {
            const MAX_RECIPIENTS_PER_WA_CAMPAIGN = AppHelper.getSetting(this.orgId, 'MAX_RECIPIENTS_PER_WA_CAMPAIGN')
            const maxReachout = Math.min(MAX_RECIPIENTS_PER_WA_CAMPAIGN,segmentSize)
            const credits = this.campaign && this.campaign.stats &&  this.campaign.stats.whatsapp && this.campaign.stats.whatsapp.credits;
            tiles = [
              { title: 'Segment Size', value: segmentSize },
              { title: 'Max Reachout', value: maxReachout },
              { title: 'Balance Credits', value: credits && credits.balance ? credits.balance.toLocaleString() : '0'  },
            ]
          }
        }

      }
    } else if (this.campaignType === 'AD') {
      tiles = [
        { title: 'Screens', value: '1,241' },
        { title: 'Impressions', value: '1,304,432' },
      ]
    }
    return <div className={css(Styles.containerNarrow)}>
      {tiles.length > 0 && <Grid container spacing={2} className={css(CommonStyles.statContainer)}>
        {tiles.map((tile, index) => (
          <StatCard
            {...(this.campaign.channel === 'WHATSAPP' ? { sm: 2 } : {})}
            key={tile.title}
            text={tile.value}
            subText={tile.title.toLocaleUpperCase()}
            cardIndex={index}
          />
        ))}
      </Grid>}
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <SubEntityCard
            renderFieldsRowwise={true}
            title={'Campaign Detail'} formDefinition={this.fieldDefCampaignBroadcast}
            item={this.campaign || {}}
            openModalForEdit={(current) => this.openModalForEditCampaign(current)}
          />
        </Grid>
        {this.campaign && this.campaign.channel === 'EMAIL' && this.emailTemplate && <Grid item xs={12} sm={6}>
          <SubEntityCard
            renderFieldsRowwise={true}
            title={'Email Metadata'} formDefinition={this.emailTemplateFieldDef}
            item={this.emailTemplate || {}}
            openModalForEdit={(current) => this.openModalForEditEmailPage(current)}
          />
        </Grid>}
        {this.campaign && this.campaign.channel === 'WHATSAPP' && this.waSettings && <Grid item xs={12} sm={6}>
          <SubEntityCard
            renderFieldsRowwise={true}
            title={'Template'} formDefinition={this.whatsappMetadataCardFieldDef}
            item={this.waSettings || {}}
            openModalForEdit={(current) => this.openModalForEditWhatsAppMetaData(current)}
            noEdit={this.campaign.state !== 'DRAFT'}
          />
        </Grid>}
      </Grid>
      {this.campaign && this.campaign.channel === 'EMAIL' && this.emailTemplate && <Grid container spacing={4}>
        <Grid item xs={12} sm={12}>
          <SubEntityList
            title={'Email Content'}
            tableHeadersMap={this.emailTemplateHeaders}
            items={Helper.sortDictArray(Helper.dictToArray(this.emailTemplate.blocks))}
            subEntityActions={this.emailTemplateSubEntityActions.bind(this)}
            noAdd={this.campaign.state !== 'DRAFT'}
            currentOrderChangeIndex={this.state.currentOrderChangeIndex}
            orderChangeEvent={this.state.orderChangeEvent}
            fetchState={this.state.fetchState}
            isOrderChanged={this.state.isOrderChanged}
            orderUp={this.orderUp.bind(this)}
            orderDown={this.orderDown.bind(this)}
            orderUIMode={this.state.orderUIMode}
            // openModalForEdit={(current) => this.openModalForTemplateEdit(current)}
            // openModalForDelete={(current) => this.openModalForTemplateDelete(current)}
            openModalForAdd={() => this.setState({ blockSelectionModal: true})}
            openPreview={() => window.open('/admin/orgs/' + this.orgId + '/preview?templateId=' + this.emailTemplate.id, 'slixtaPreivew')}
          />
        </Grid>
      </Grid>}

      {this.campaign && this.campaign.channel === 'WHATSAPP' && this.campaign.waTemplate && <Grid container spacing={4}>
        <Grid item xs={12} sm={12}>
          <SubEntityList
            title={'Template Content'}
            tableHeadersMap={this.waTemplateHeaders}
            items={this.campaign.waTemplate.components || []}
            noAdd={true}
            noEdit={true}
            noDelete={true}
            fetchState={this.state.fetchState}
            // openPreview={() => null}
          />
        </Grid>
      </Grid>}
      {this.campaign && this.campaign.channel === 'WHATSAPP' && this.waSettings && <Grid container spacing={4}>
        <Grid item xs={12} md={8}>
          <SubEntityList
            title={'Template Variables'}
            tableHeadersMap={this.waTemplateVariablesHeaders}
            items={Helper.sortDictArray(Helper.dictToArray(this.waSettings.waComponents), 'id')}
            subEntityActions={this.waTemplateSubEntityActions.bind(this)}
            noAdd={true}

            fetchState={this.state.fetchState}
            // openPreview={() => null}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <div className={css(Styles.previewPane)}>
            <div className={css(Styles.previewCard)}>
              <div className={css(Styles.previewTitle)}>Preview</div>
              <div className={css(Styles.previewBody)}>
                <WhatsappTemplatePreview
                  components={buildPreviewComponentsFromTemplate(
                    this.campaign.waTemplate && this.campaign.waTemplate.components,
                    this.waSettings.waComponents,
                    { hideTemplateExamplesWhenUnset: true }
                  )}
                />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>}
      {this.campaign && (this.campaign.channel === 'WHATSAPP' || isSesBroadcast(this.campaign)) && this.campaign.state === 'COMPLETED' && Array.isArray(this.state.interactions) && <Grid container>
        <Grid item xs={12}>
          {this.renderIndividualStats()}
        </Grid>
      </Grid>
      }
    </div>
  }

  renderIndividualStats() {
    const isSes = isSesBroadcast(this.campaign)
    const headersMap = isSes ? this.individualEmailStatsTableHeadersMap : this.individualStatsTableHeadersMap

    return <div className={css(Styles.container)}>
      <div className={css(Styles.individualStatsHeaderContainer)}>
        <div className={css(Styles.headingContent)}>
          <h2 className={css(Styles.individualStatsTitle)}>{'Campaign Results'}</h2>
        </div>
      </div>
      <div className={css(Styles.content, Styles.contentForRow)}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12}>
            <SubEntityList
              noAdd={true}
              isChildTable={true}
              tableHeadersMap={headersMap}
              items={this.state.interactions}
              subEntityActions={this.individualStatsActions.bind(this)}
              fetchState={this.state.fetchState}
              nextPage={this.state.interactionsNextPage}
              onNext={async () => {
                const nextPageInteractions = await ApiHelper.callAwait({
                  ms: AppConfig.CDP_MS.ENDPOINT,
                  method: 'GET',
                  paths: ['crminteractions'],
                  queryParams: {orgId: this.orgId, campaignId: this.campaignId, nextPage: this.state.interactionsNextPage, limit: 500}}
                )
                if (this.campaign.channel === 'WHATSAPP' && this.campaign.state === 'COMPLETED' && Array.isArray(this.campaign._executionResults) && nextPageInteractions.items.length > 0) {
                  nextPageInteractions.items.forEach(ci => {
                    const waRequestPhoneNumber = ci.payload && ci.payload.waRequest && Array.isArray(ci.payload.waRequest.messageParams) && ci.payload.waRequest.messageParams[0] && ci.payload.waRequest.messageParams[0].toNumber || ''
                    ci._waMsgResponse = this.campaign._executionResults.find(er => er.contactPhone === waRequestPhoneNumber)
                  })
                }
                this.setState({
                  interactions: this.state.interactions.concat(nextPageInteractions.items),
                  interactionsNextPage: nextPageInteractions.nextPage
                })
              }}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  }

  individualStatsActions = (current) => {
    const actions = []
    if (current.userId) {
      actions.push(
        <Link to={this.baseRoute() + '/crm-contacts/' + current.userId} key={'viewcontact-' + current.userId}>
          <Tooltip title='View Contact' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>person</i>
            </span>
          </Tooltip>
        </Link>
      )
    }
    return actions
  }

  onOrderEdit(orderEditData) {
    const { current, otherItem } = orderEditData
    const apiPayload = {
      entityAction: 'edit',
      entityAttrName: this.entityAttrName,
      id: current.id,
    }

    const orderChangePayload = {
      current,
      otherItem,
      apiMethod: 'PUT',
      apiEndPoint: ApiHelper.makeUrlPath(['emailpages', this.emailTemplate.id], {}),
      apiPayload
    }
    this.onOrderChange(orderChangePayload)
  }


  emailTemplateSubEntityActions = (current) => {
    function patchFields(fieldDef) {
      if (this.campaign.state !== 'DRAFT') {
        fieldDef.disableCTAButton = true
        fieldDef.steps[0].fields.forEach(f => f.disabled = true)
      }
    }

    const isDisabled = (this.campaign.state !== 'DRAFT') ? true : false

    const actions = []
    actions.push(<Tooltip title={'Edit section'} placement='top-start' key={current.id + 'editTT'}>
      <span className={css(AppStyles.entityTableLinkIcon)}>
        <i className='material-icons-outlined' onClick={() => this.openModalForEditTemplateWidget(current)}>edit</i>
      </span>
    </Tooltip>)
    if (this.campaign.state === 'DRAFT') actions.push(<Tooltip title='Delete' placement='top-start' key={current.id + 'deleteTT'}>
      <span className={css(AppStyles.entityTableLinkIcon)}>
        <i className='material-icons-outlined' onClick={() => this.openModalForDeleteTemplateWidget(current)}>delete</i>
      </span>
    </Tooltip>)
    if (current.cbSource === 'GLOBAL' || current.cbSource === 'TENANT') {
      if(current._singleton  === 'YES') {
        // Dont go to another page for convenience of only one item to be edited
        actions.push(
          <Tooltip title={Helper.getString('emailcbdats')} placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'
                onClick={() => AppUiHelper.handleEmailSingletonWidgetData(this, current, null, patchFields.bind(this), isDisabled)}>dataset</i>
            </span>
          </Tooltip>
        )
        if (current._cbstyle === 'ITEMBLOCK1' && this.campaign.state === 'DRAFT') {
          actions.push(
            <Tooltip title={Helper.getString('quickfill')} placement='top-start'>
              <span className={css(AppStyles.entityTableLinkIcon)}>
                <i className='material-icons-outlined'
                  onClick={() => this.openModalForScrapeBlog(current)}>dynamic_form</i>
              </span>
            </Tooltip>
          )
        }
      }
    }
    return actions
  }

  waTemplateSubEntityActions = (current) => {
    const actions = []
    if (this.campaign && this.campaign.state === 'DRAFT') {
      actions.push(<Tooltip title={'Edit Variable'} placement='top-start' key={current.id + 'editTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons-outlined' onClick={() => this.openModalForEditWATemplateVariable(current)}>edit</i>
        </span>
      </Tooltip>)
    }
    return actions
  }

  openModalForEditCampaign(current) {
    const fields = getCampaignFields(this)
    fields.find(f => f.key === 'title')
    const disableAlwaysFormFields = current.state === 'DRAFT' ? [] : ['channel', 'templateId', 'transactionalEvent', 'notificationEvent', 'segmentId']
    this.formDefinition = {steps: [{ fields }], disableAlwaysFormFields}
    this.formDefinition.formType = 'edit'
    this.formDefinition.title = 'Campaign Detail'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.setState({
      apiMethod: 'PUT',
      apiData: {orgId: this.orgId},
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['campaigns', current.id], queryParams: {orgId: this.orgId} }),
    });
    this.setState({
      modalOpen: true
    });
  }

  openModalForEditEmailPage(current) {
    this.formDefinition = JSON.parse(JSON.stringify(this.emailTemplateFieldDef))
    this.formDefinition.disableAlwaysFormFields = this.campaign.state === 'DRAFT' ? [] : ['subject', 'previewText', 'titleText']
    this.formDefinition.formType = 'edit'
    this.formDefinition.title = 'Email Metadata'
    if (this.campaign.state !== 'DRAFT') {
      this.formDefinition.disableCTAButton = true
    }
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.setState({
      apiMethod: 'PUT',
      apiData: {orgId: this.orgId},
      apiEndPoint: ApiHelper.makeUrlPath2({ paths: ['emailpages', current.id], queryParams: {} }),
    });
    this.setState({
      modalOpen: true
    });
  }

  openModalForEditWhatsAppTemplate(current, templates) {
    let fieldDef =  getWhatsAppMetadataFieldDef({
      waAccounts: this.waAccounts,
      waTemplates: templates,
      orgId: this.orgId,
      ctaButtonText: 'Save',
      current,
    })
    fieldDef = {
      ...fieldDef,
      steps: fieldDef.steps.map(step => ({
        ...step,
        fields: [ step.fields[1] ]
      }))
    }
    this.formDefinition = fieldDef
    this.formDefinition.formType = 'edit'
    if (this.campaign.state !== 'DRAFT') {
      this.formDefinition.disableCTAButton = true
    }
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.setState({
      apiData: {
        waTemplate: current || {},
        templates: templates || [],
        isEditWhatsAppTemplate: true,
      },
      modalOpen: true
    });
  }

  openModalForEditWhatsAppMetaData(current) {
    let fieldDef = getWhatsAppMetadataFieldDef({
      waAccounts: this.waAccounts,
      orgId: this.orgId,
      current,
    })
    fieldDef = {
      ...fieldDef,
      steps: fieldDef.steps.map(step => ({
        ...step,
        fields: [ step.fields[0] ]
      }))
    }
    this.formDefinition = fieldDef
    this.formDefinition.formType = 'edit'
    if (this.campaign.state !== 'DRAFT') {
      this.formDefinition.disableCTAButton = true
    }
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.setState({
      apiData: {
        waTemplate: current || {},
        isEditWhatsAppMetaData: true,
      },
      modalOpen: true
    });
  }

  openModalForAddTemplateWidget(fieldDef) {
    this.formDefinition = JSON.parse(JSON.stringify(fieldDef))
    this.formDefinition.formType = 'add'
    Helper.deleteFormDefinitionValues(this.formDefinition)
    this.formDefinition.disableAlwaysFormFields = ['cbSource', 'cbTenantId', 'cbGlobalId', 'cbSiteBlockId']
    if (this.state.selectedBlockSource === 'GLOBAL') {
      this.formDefinition.steps[0].fields.find(i => i.key === 'cbGlobalId').disabled = true
      this.formDefinition.steps[0].fields.find(i => i.key === 'cbGlobalId').value = this.state.selectedBlockType
    // } else if (this.state.selectedBlockSource === 'TENANT') {
    //   this.formDefinition.steps[0].fields.find(i => i.key === 'cbTenantId').disabled = true
    //   this.formDefinition.steps[0].fields.find(i => i.key === 'cbTenantId').value = this.state.selectedBlockType
    // } else if (this.state.selectedBlockSource === 'SITE') {
    //   this.formDefinition.steps[0].fields.find(i => i.key === 'cbSiteBlockId').disabled = true
    //   this.formDefinition.steps[0].fields.find(i => i.key === 'cbSiteBlockId').value = this.state.selectedBlockType
    }

    this.formDefinition.steps[0].fields.find(i => i.key === 'cbSource').disabled = true
    this.formDefinition.steps[0].fields.find(i => i.key === 'cbSource').value = this.state.selectedBlockSource
    this.formDefinition.steps[0].fields.find(i => i.key === 'cbSource').defaultValue = this.state.selectedBlockSource

    if(this.emailTemplate && this.emailTemplate.blocks) {
      const emailTemplateBlocks = Object.values(this.emailTemplate.blocks)
      const newOrder = AppHelper.generateNewOrder(emailTemplateBlocks)
      this.formDefinition.steps[0].fields.find(i => i.key === 'order').defaultValue = newOrder
    }

    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'add', entityAttrName: 'blocks', orgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath(['emailpages', this.emailTemplate.id], {}),
      modalOpen: true,
    });
  }

  openModalForEditTemplateWidget(current) {
    this.formDefinition = JSON.parse(JSON.stringify(this.emailTemplate.fieldDefPageBlock))
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.formDefinition.steps[0].fields.find(i => i.key === 'cbSource').disabled = true
    this.formDefinition.steps[0].fields.find(i => i.key === 'cbGlobalId').disabled = true
    if (this.campaign.state !== 'DRAFT') this.formDefinition.steps[0].fields.forEach(f => f.disabled = true)
    // this.formDefinition.steps[0].fields.find(i => i.key === 'cbTenantId').disabled = true
    // this.formDefinition.steps[0].fields.find(i => i.key === 'cbSiteBlockId').disabled = true
    if (this.campaign.state !== 'DRAFT') {
      this.formDefinition.disableCTAButton = true
    }
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'edit', entityAttrName: 'blocks', id: current.id, orgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath(['emailpages', this.emailTemplate.id], {}),
      modalOpen: true,
    });
  }

  openModalForEditWATemplateVariable(current) {
    current = JSON.parse(JSON.stringify(current))
    if (current && String(current.format || '').toLowerCase() === 'document' && (!current.fileName || !String(current.fileName).trim())) {
      current.fileName = 'Untitled'
    }
    if (current.text && AppUiHelper.getContactTemplateVariables(this.crmContactsFieldDef).every(ctv => ctv.value !== current.text)) {
      current.customText = current.text
      current.text = 'custom'
    }
    this.formDefinition = getFieldDefWATemplateVariable(current, this.crmContactsFieldDef)
    this.formDefinition.formType = 'edit'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    if (this.campaign.state !== 'DRAFT') this.formDefinition.steps[0].fields.forEach(f => f.disabled = true)

    if (this.campaign.state !== 'DRAFT') {
      this.formDefinition.disableCTAButton = true
    }

    if(this.campaign && this.campaign.id) {
      this.setState({
        apiMethod: 'PUT',
        apiData: { entityAction: 'edit', entityAttrName: 'waComponents', id: current.id, value:current.value, orgId: this.orgId},
        apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['campaigns', this.campaign.id], queryParams: {orgId: this.orgId} }),
        modalOpen: true,
      });
    }
  }

  openModalForDeleteTemplateWidget(current) {
    this.formDefinition = JSON.parse(JSON.stringify(this.emailTemplate.fieldDefPageBlock))
    this.formDefinition.formType = 'delete'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.setState({
      apiMethod: 'PUT',
      apiData: { entityAction: 'del', entityAttrName: 'blocks', id: current.id, orgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath(['emailpages', this.emailTemplate.id], {}),
      modalOpen: true,
    });
  }

  openModalForCampaignUpdateAction(current, action, fieldDef) {
    this.formDefinition = fieldDef
    this.formDefinition.formType = 'edit'
    this.formDefinition.title = 'Edit Campaign State'
    Helper.populateFormDefinitionValues(this.formDefinition, current)
    this.setState({
      apiMethod: 'PUT',
      apiData: { updateAction: action, orgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['campaigns', current.id], queryParams: {orgId: this.orgId} }),
      modalOpen: true
    });
  }

  onCompleteAction(options) {
    this.setState({
      modalOpen: false,
      dialogApiData: options && options.apiInvokeData,
      loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD,
    })
    this.fetchItems()
  }

  async updateCampaignState(current, action) {
    if (['AD', 'BROADCAST'].includes(current.iType) && action === 'start') {
      this.fieldDefCampaignSchedule.ctaButtonText = 'Start'

      if (this.emailMetadataIssues && this.emailMetadataIssues.length > 0) {
        const fieldDefWithValidation = JSON.parse(JSON.stringify(this.fieldDefCampaignSchedule))
        fieldDefWithValidation.errorMessage = this.emailMetadataIssues.join(', ')
        this.openModalForCampaignUpdateAction(current, action, fieldDefWithValidation)
      } else {
        this.openModalForCampaignUpdateAction(current, action, this.fieldDefCampaignSchedule)
      }
    } else {
      const fields = [{
        key: 'updateAction',
        label: 'Update action',
        type: 'edit_text',
        hint: 'Update action',
        // eslint-disable-next-line camelcase
        v_required: { value: true, err: 'Provide update action' },
        placement: 'left',
        value: action,
        disabled: true,
      }]
      current.updateAction = action
      this.openModalForCampaignUpdateAction(current, action, {steps: [{ fields }]});
    }
  }

  doActionNext = (selectedBlockSource, selectedBlockType) => {
    this.setState({
      blockSelectionModal: false,
      selectedBlockSource: selectedBlockSource,
      selectedBlockType: selectedBlockType
    }, () => this.openModalForAddTemplateWidget(this.emailTemplate.fieldDefPageBlock, this.cbGlobalById[selectedBlockType].cbstyle))
  }

  renderBelowTable() {
    return this.state.blockSelectionModal ? this.renderBlockSelectionModal() : ''
  }

  renderBlockSelectionModal() {
    return (
      <CbSelection
        title={Helper.getString('emailblockSelection')}
        isOpen={this.state.blockSelectionModal}
        onClosed={() => this.setState({ blockSelectionModal: false})}
        cbOrg={this.cbOrg}
        selectedBlock={'GLOBAL'}
        cbGlobal={this.cbGlobal}
        cbSource={this.cbSource}
        cbSite={this.cbSite}
        doActionNext={this.doActionNext}
        page={this.emailTemplate}
        compactView={true}
      />
    );
  }

  openModalForScrapeBlog(current) {
    this.formDefinition = {
      steps: [
        {
          fields: [
            {
              key: 'contentUrl',
              type: 'edit_text',
              label: 'Content Url [Optional]',
              v_required: { value: false }, // eslint-disable-line camelcase
              placement: 'left'
            },
          ]
        }
      ],
      formType: 'add',
      title: `Quick Fill ${(current && (current.title || current._widgetName)) || 'Widget'}`,
      ctaButtonText: 'Next',
    }
    let _linkPreview, _signedUploadInfo
    this.customSubmit = (options) => {
      this.customSubmit = null
      //const fieldDef = JSON.parse(JSON.stringify(this.emailTemplate.fieldDefPageBlock))
      const { formData } = options
      const _this = this
      //const _openModalForAdd = this.openModalForAddTemplateWidget.bind(this)
      function enhanceFields(fieldDef) {
        if (_linkPreview) {
          const titleField = fieldDef.steps[0].fields.find(f => f.key === 'title')
          titleField.defaultValue = _linkPreview.title || ''
          titleField.value = titleField.defaultValue
          const descriptionField = fieldDef.steps[0].fields.find(f => f.key === 'description')
          descriptionField.defaultValue = _linkPreview.description || ''
          descriptionField.value = descriptionField.defaultValue
        }
        const navLinkField = fieldDef.steps[0].fields.find(f => f.key === 'navLink')
        navLinkField.defaultValue = formData.contentUrl || ''
        navLinkField.value = navLinkField.defaultValue
        if (_signedUploadInfo) {
          const imageField = fieldDef.steps[0].fields.find(f => f.key === 'image')
          imageField.link = _signedUploadInfo.link
          imageField.value = _signedUploadInfo.fields.key
        }
      }
      function loadForm() {
        _this.setState({ fetchState: ApiHelper.State.READY, modalOpen: false }, () => {
          //_openModalForAdd(fieldDef)//, false)
          AppUiHelper.handleEmailSingletonWidgetData(_this, current, enhanceFields.bind(_this))
        })
      }
      if (formData.contentUrl) {
        ApiHelper.callAwait({
          ms: AppConfig.CDP_MS.ENDPOINT,
          method: 'get',
          paths: ['miscs', 'get-link-preview'],
          queryParams: {link: formData.contentUrl}}
        ).then(linkPreview => {
          _linkPreview = linkPreview
          if (linkPreview.imageData) {
            const imageBlob = Helper.b64toBlob(linkPreview.imageData.base64, linkPreview.imageData.type);
            const options = {
              uploadLocation: this.orgId,
              type: 'media',
              //contentType: linkPreview.imageData.contentType,
              ext:  linkPreview.imageData.extension,
            }
            return UploadHelper.fetchUploadUrlAwait(null, options).then(signedUploadInfo => {
              _signedUploadInfo = signedUploadInfo
              const file = new File([imageBlob], 'untitled', { type: linkPreview.imageData.contentType })
              return UploadHelper.uploadFormDataAwait({
                signedUploadInfo,
                pickerResult: file,
              })
            })
          }
        }).then(() => loadForm()).catch(err => {
          console.log(err)
          loadForm()
        })
      } else {
        loadForm()
      }
    }
    this.setState({
      modalOpen: true
    });
  }

  async customSubmitForWhatsAppMetaData(options) {
    const { formType, formData, caller } = options

    delete formData.isEditWhatsAppMetaData
    if(formData && this.waAccounts) {
      const selectedFromNumber = formData.fromNumber
      const waTemplates = await ApiHelper.callAwait({
        ms: AppConfig.CDP_MS.ENDPOINT,
        method: 'GET',
        paths: ['miscs', 'get-wa-templates'],
        queryParams: {orgId: this.orgId, fromNumber: selectedFromNumber}
      }).then(templates => templates.filter(template => template.status === 'APPROVED'))
      const waTemplate = {
        ...formData.waTemplate,
        fromNumber: selectedFromNumber,
      }
      if (selectedFromNumber !== this.campaign.fromNumber) {
        waTemplate.templateId = ''
      }
      this.setState({
        modalOpen: false
      }, ()=>{
        this.openModalForEditWhatsAppTemplate(waTemplate, waTemplates)
      })
    } else {
      this.setState({
        modalOpen: false
      })
    }
  }

  async customSubmitForEditWhatsAppTemplate(options) {
    const { formType, formData, caller } = options

    delete formData.isEditWhatsAppTemplate

    if(formData) {
      const selectedTemplate = formData.templateId
      const waTemplate = {
        ...formData.waTemplate,
        templateId: selectedTemplate
      }

      if(waTemplate && waTemplate.fromNumber && waTemplate.templateId && this.campaign && this.campaign.id) {
        ApiHelper.callAwait({
          ms: this.ms,
          method: 'PUT',
          jsonBody: { orgId: this.orgId, fromNumber: waTemplate.fromNumber, templateId: waTemplate.templateId },
          paths: ['campaigns', this.campaign.id],
          queryParams: {orgId: this.orgId}}
        ).then(response => {
          this.setState({
            fetchState: ApiHelper.State.READY,
            modalOpen: false
          },()=>{
            this.fetchItems()
          })
        }).catch(err => {
          const errorMessage = Helper.getErrorMsg(err)
          caller.setState({
            success: false,
            message: errorMessage,
            inProcess: false,
          })
        })
      } else {
        this.setState({
          fetchState: ApiHelper.State.READY,
          modalOpen: false
        })
      }
    }
  }

  async customSubmitForEditWATemplateVariable(options) {
    const { formType, formData, caller } = options
    const apiData = JSON.parse(JSON.stringify(formData))
    if (apiData.text === 'custom') { apiData.text = apiData.customText }
    const currentFormat = apiData.format ? String(apiData.format).toLowerCase() : ''
    if (currentFormat === 'document' && (apiData.media || apiData.mediaLink) && (!apiData.fileName || !String(apiData.fileName).trim())) {
      apiData.fileName = 'Untitled'
    }
    return caller.submit.call(caller, apiData, true);
  }

  customSubmitForCampaignUpdateAction(options) {
    const { formData, caller } = options
    ApiHelper.call(
      { method: this.state.apiMethod, endPoint: this.state.apiEndPoint, jsonBody: formData },
      (err, data) => {
        if (err) {
          caller.setState({
            success: false,
            message: Helper.getErrorMsg(err),
            inProcess: false,
          })
          return
        }
        caller.setState({
          success: true,
          message: Helper.getString('successful'),
          inProcess: false,
        })
        if (caller.props.onCompleteAction) {
          caller.props.onCompleteAction({
            apiInvokeData: {
              method: this.state.apiMethod,
              endPoint: this.state.apiEndPoint,
              reqBody: formData,
              responseBody: data,
            },
          })
        }
      }
    )
  }

  async customSubmit(options) {
    const { formType, formData, caller } = options
    if (formData.isEditWhatsAppMetaData) { return this.customSubmitForWhatsAppMetaData(options) }
    if (formData.isEditWhatsAppTemplate) { return this.customSubmitForEditWhatsAppTemplate(options) }
    if (formData.entityAttrName === 'waComponents') { return this.customSubmitForEditWATemplateVariable(options) }
    if (formData.updateAction) { return this.customSubmitForCampaignUpdateAction(options) }
    return caller.submit.call(caller, formData, true);
  }

  handleCancelBroadcast() {
    this.formDefinition = {
      steps: [{ fields: [] }],  // Empty fields array
      formType: 'edit',
      title: 'Cancel Broadcast',
      ctaButtonText: 'Cancel',
      confirmMessage: 'Are you sure you want to cancel this broadcast?'
    }
    this.setState({
      apiMethod: 'PUT',
      apiData: { updateAction: 'cancel', orgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['campaigns', this.campaign.id], queryParams: {orgId: this.orgId} }),
      modalOpen: true
    });
  }

  openModalForRescheduleBroadcast() {
    const originalScheduleTs = moment(this.campaign.scheduleTs, 'Do MMM YYYY, h:mm a').valueOf();
    const fields = [{
      key: 'scheduleTs',
      type: 'dateTime',
      label: 'Reschedule On',
      tip: 'Select new schedule date and time',
      v_required: { value: true, err: 'Provide new schedule date' },
      placement: 'left',
      value: originalScheduleTs,
    }]
    this.formDefinition = {
      steps: [{ fields }],
      formType: 'edit',
      title: 'Reschedule Broadcast',
      ctaButtonText: 'Reschedule'
    }
    this.setState({
      apiMethod: 'PUT',
      apiData: { updateAction: 'reschedule', orgId: this.orgId },
      apiEndPoint: ApiHelper.makeUrlPath2({ ms: this.ms, paths: ['campaigns', this.campaign.id], queryParams: {orgId: this.orgId} }),
      modalOpen: true
    });
  }
}

const Styles = StyleSheet.create({
  line1: {
    fontSize: 16
  },
  line2: {
    fontSize: 12,
    color: 'gray'
  },
  line3: {
    fontSize: 10,
    color: 'gray'
  },
  spanValue: {
    fontSize: 12
  },
  preWrapText: {
    whiteSpace: 'pre-wrap',
  },
  imagePreview: {
    width: '100px',
    height: 'auto',
    display: 'block'
  },
  videoPreview: {
    width: '100px',
    height: 'auto',
    display: 'block'
  },
  imageWrapper: {
    display: 'block',
  },
  videoWrapper: {
    display: 'block',
  },
  containerNarrow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: AppTheme.viewPort,
    paddingBottom: 50,
    width: '100%',
    '@media (max-width: 767px)': {//TODO: next?
      //width: window.innerWidth - 20 //TODO: fix it, in product screen whitespace nowrap creating issue
    },
  },
  container: {
    background: 'white',
    border: CommonTheme.containerBorderColor,
    height: '100%',
    borderRadius: 16,
  },
  individualStatsHeaderContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  headingContent: {
    padding: '18px 5px 18px 30px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '@media (max-width: 767px)': {
      padding: '18px 5px 18px 15px',
    }
  },
  individualStatsTitle: {
    color: CommonTheme.textColor,
    fontSize: 20,
    fontWeight: 600,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    marginRight: 10
  },
  content: {
    padding: '0px 30px',
    marginBottom: -3,
    '@media (max-width: 767px)': {
      padding: '0px 15px',
    }
  },
  contentForRow: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  previewPane: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  previewCard: {
    width: '100%',
    minHeight: '100%',
    background: '#fff',
    border: '1px solid #e5e7eb',
    borderRadius: 14,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
    padding: 16,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },
  previewTitle: {
    width: '100%',
    fontSize: 15,
    fontWeight: 600,
    color: '#374151',
    marginBottom: 12,
    paddingLeft: 2,
  },
  previewBody: {
    width: '100%',
    flex: 1,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
})